var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMobileNavEndingManage = function SvgIcnMobileNavEndingManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.712 7.10406H6.48799C5.11999 7.10406 4 8.22405 4 9.59205V18.6801C4 19.8401 4.832 20.3361 5.848 19.7681L8.99199 18.0161C9.32799 17.8321 9.872 17.8321 10.2 18.0161L13.344 19.7681C14.36 20.3361 15.192 19.8401 15.192 18.6801V9.59205C15.2 8.22405 14.08 7.10406 12.712 7.10406Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 9.59205V18.6801C15.2 19.8401 14.368 20.3281 13.352 19.7681L10.208 18.0161C9.87201 17.8321 9.32799 17.8321 8.99199 18.0161L5.848 19.7681C4.832 20.3281 4 19.8401 4 18.6801V9.59205C4 8.22405 5.11999 7.10406 6.48799 7.10406H12.712C14.08 7.10406 15.2 8.22405 15.2 9.59205Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.48799V15.576C20 16.736 19.1681 17.224 18.1521 16.664L15.2 15.016V9.59199C15.2 8.22399 14.0801 7.104 12.7121 7.104H8.80005V6.48799C8.80005 5.11999 9.92004 4 11.288 4H17.5121C18.8801 4 20 5.11999 20 6.48799Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMobileNavEndingManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_mobile_nav_ending_manage.359732e3.svg";
export { ForwardRef as ReactComponent };